const CONFIG = {
  timezone: 'America/New_York',
  cutoffHour: 15,
  cutoffMinute: 0,
  businessDays: [1, 2, 3, 4, 5],
  holidays: [
    '2026-01-01',
    '2026-01-19',
    '2026-02-16',
    '2026-05-25',
    '2026-06-19',
    '2026-07-03',
    '2026-07-04',
    '2026-09-07',
    '2026-10-12',
    '2026-11-11',
    '2026-11-26',
    '2026-12-25',
    '2027-01-01',
    '2027-01-18',
    '2027-02-15',
    '2027-05-31',
    '2027-06-18',
    '2027-06-19',
    '2027-07-05',
    '2027-09-06',
    '2027-10-11',
    '2027-11-11',
    '2027-11-25',
    '2027-12-24',
    '2027-12-25'
  ]
};

function partsInZone(date, tz) {
  const fmt = new Intl.DateTimeFormat('en-US', {
    timeZone: tz,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23'
  });
  const map = {};
  fmt.formatToParts(date).forEach(function (p) {
    map[p.type] = p.value;
  });
  const days = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  return {
    hour: Number(map.hour),
    minute: Number(map.minute),
    weekday: days[map.weekday],
    dateKey: map.year + '-' + map.month + '-' + map.day
  };
}

function canShipTodayNow() {
  const p = partsInZone(new Date(), CONFIG.timezone);
  if (CONFIG.businessDays.indexOf(p.weekday) === -1) return false;
  if (CONFIG.holidays.indexOf(p.dateKey) !== -1) return false;
  return p.hour * 60 + p.minute < CONFIG.cutoffHour * 60 + CONFIG.cutoffMinute;
}

function countdownText() {
  const p = partsInZone(new Date(), CONFIG.timezone);
  const mins = Math.max(0, CONFIG.cutoffHour * 60 + CONFIG.cutoffMinute - (p.hour * 60 + p.minute));
  return Math.floor(mins / 60) + 'h ' + (mins % 60) + 'm';
}

function refreshBadges() {
  var cutoff = document.querySelector("[data-cvt-cutoff]");
  if (cutoff) cutoff.textContent = "";

  var shipToday = canShipTodayNow();

  document.querySelectorAll(".cvt__row").forEach(function (row) {
    var badge = row.querySelector("[data-cvt-badge]");
    if (!badge) return;
    if (row.getAttribute("data-ships-today") !== "true") {
      badge.innerHTML = "";
      return;
    }
    badge.innerHTML = shipToday
      ? '<span class="cvt__pill cvt__pill--today">SHIPS TODAY</span>'
      : '<span class="cvt__pill cvt__pill--today">IN STOCK</span>';
  });
}

function ensureModal() {
  var modal = document.querySelector('[data-cvt-modal]');
  if (modal) return modal;
  modal = document.createElement('dialog');
  modal.className = 'cvt-modal';
  modal.setAttribute('data-cvt-modal', '');
  modal.innerHTML =
    '<button type="button" class="cvt-modal__close" data-cvt-close aria-label="Close">x</button>' +
    '<img src="" alt="" width="900" height="900" data-cvt-modal-img>';
  document.body.appendChild(modal);
  return modal;
}

function openModal(src, alt) {
  if (!src) return;
  var modal = ensureModal();
  var img = modal.querySelector('[data-cvt-modal-img]');
  img.src = src.indexOf('//') === 0 ? 'https:' + src : src;
  img.alt = alt || '';
  if (typeof modal.showModal === 'function') modal.showModal();
  else modal.setAttribute('open', '');
}

function closeModal() {
  var modal = document.querySelector('[data-cvt-modal]');
  if (!modal) return;
  if (typeof modal.close === 'function') modal.close();
  else modal.removeAttribute('open');
}

function parseSection(html, selectors) {
  if (!html) return null;
  var doc = new DOMParser().parseFromString(html, 'text/html');
  var fresh = null;
  (selectors || []).some(function (sel) {
    fresh = doc.querySelector(sel);
    return !!fresh;
  });
  return fresh || doc.querySelector('.shopify-section') || doc.body.firstElementChild;
}

function updateCartUI(sections) {
  var drawer = document.querySelector('cart-drawer');

  if (drawer && sections['cart-drawer']) {
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var newDrawer = doc.querySelector('cart-drawer');

    if (newDrawer) {
      drawer.replaceWith(newDrawer);
      drawer = document.querySelector('cart-drawer');
    } else {
      var freshInner = parseSection(sections['cart-drawer'], ['.drawer__inner', '#CartDrawer']);
      var currentInner = drawer.querySelector('.drawer__inner') || drawer.querySelector('#CartDrawer');
      if (freshInner && currentInner) currentInner.innerHTML = freshInner.innerHTML;
    }

    if (drawer && typeof drawer.open === 'function') drawer.open();
    else if (drawer) drawer.classList.add('active');
  } else if (sections['cart-notification']) {
    var note = document.querySelector('cart-notification');
    var freshNote = parseSection(sections['cart-notification'], ['cart-notification']);
    if (note && freshNote) note.innerHTML = freshNote.innerHTML;
    note = document.querySelector('cart-notification');
    if (note && typeof note.open === 'function') note.open();
  }

  if (sections['cart-icon-bubble']) {
    var bubble = document.getElementById('cart-icon-bubble');
    var freshBubble = parseSection(sections['cart-icon-bubble'], ['#cart-icon-bubble', '.shopify-section']);
    if (bubble && freshBubble) bubble.innerHTML = freshBubble.innerHTML;
  }
}

function addToCart() {
  var buttons = document.querySelectorAll('[data-cvt-add]');
  var statuses = document.querySelectorAll('[data-cvt-status]');
  var items = [];

  function setStatus(text) {
    statuses.forEach(function (s) {
      s.hidden = false;
      s.textContent = text;
    });
  }

  function setDisabled(state) {
    buttons.forEach(function (b) { b.disabled = state; });
  }

  document.querySelectorAll('.cvt__row').forEach(function (row) {
    var qty = Number((row.querySelector('[data-qty-input]') || {}).value || 0);
    if (qty > 0) {
      items.push({
        id: Number(row.getAttribute('data-variant-id')),
        quantity: qty
      });
    }
  });

  if (!items.length) {
    setStatus('Enter a quantity for at least one option.');
    return;
  }

  setDisabled(true);
  setStatus('Adding to cart...');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({ items: items })
  })
    .then(function (res) {
      return res.json().then(function (data) {
        return { ok: res.ok, data: data };
      });
    })
    .then(function (result) {
      if (!result.ok || result.data.status) {
        throw new Error(result.data.description || result.data.message || 'Add failed');
      }

      document.querySelectorAll('[data-qty-input]').forEach(function (input) {
        input.value = 0;
      });

      setStatus('Added to cart.');

      return fetch('/?sections=cart-drawer,cart-notification,cart-icon-bubble')
        .then(function (res) { return res.json(); })
        .then(function (sections) {
          updateCartUI(sections);
        });
    })
    .catch(function (err) {
      setStatus(err.message || 'Could not add to cart. Please try again.');
    })
    .finally(function () {
      setDisabled(false);
    });
}

document.addEventListener('click', function (e) {
  var openBtn = e.target.closest('[data-cvt-open]');
  if (openBtn) {
    e.preventDefault();
    e.stopPropagation();
    openModal(openBtn.getAttribute('data-full'), openBtn.getAttribute('data-alt'));
    return;
  }

  if (e.target.closest('[data-cvt-close]') || e.target.hasAttribute('data-cvt-modal')) {
    closeModal();
    return;
  }

  var minus = e.target.closest('[data-qty-minus]');
  var plus = e.target.closest('[data-qty-plus]');
  if (minus || plus) {
    var row = e.target.closest('.cvt__row');
    var input = row && row.querySelector('[data-qty-input]');
    if (!input) return;
    var val = Number(input.value || 0);
    input.value = minus ? Math.max(0, val - 1) : val + 1;
    return;
  }

  if (e.target.closest('[data-cvt-add]')) {
    addToCart();
  }
});

refreshBadges();
setInterval(refreshBadges, 30000);